module.exports = __webpack_public_path__ + "static/img/6.7cd6d2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/6.png
// module id = P4wf
// module chunks = 0